<template>
    <q-list>
        <q-collapsible class="filter" icon="fas fa-filter" :label="$t('filter')" :opened="!$q.platform.is.mobile ? true : false">
            <q-list no-border>
                <q-item>
                    <q-item-main>
                        <q-search v-model="selected_search" :placeholder="$t('search')" icon="fas fa-search" @input="changeFilter('search')" :debounce="600" />
                    </q-item-main>
                </q-item>
            </q-list>

            <q-list no-border link>
                <q-list-header>{{ $t('areas') }}</q-list-header>

                <q-item tag="label">
                    <q-item-side>
                        <q-radio v-model="selected_areas" val="all" @input="changeFilter('areas')" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label class="text-weight-light">{{ $t('all_f') }}</q-item-tile>
                    </q-item-main>
                </q-item>

                <q-item tag="label" v-for="(area, index) in areas" :key="index">
                    <q-item-side>
                        <q-radio v-model="selected_areas" :val="area.value" @input="changeFilter('areas')" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label class="text-weight-light">{{ area.label }}</q-item-tile>
                    </q-item-main>
                </q-item>
            </q-list>

            <q-list no-border link v-if="tags.length > 0">
                <q-list-header>{{ $t('tags') }}</q-list-header>

                <q-item tag="label" v-for="(tag, index) in tags" :key="index">
                    <q-item-side>
                        <q-checkbox v-model="selected_tags" :val="tag.value" @input="changeFilter('tags')" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label class="text-weight-light">{{ tag.label }}</q-item-tile>
                    </q-item-main>
                </q-item>
            </q-list>

            <q-list no-border link>
                <q-item>
                    <q-item-main>
                        <p class="text-center">
                            <a href="#" @click.prevent="clearFilters()" class="text-faded">
                                <q-icon name="far fa-trash-alt" /> {{ $t('clear_filters') }}
                            </a>
                        </p>
                    </q-item-main>
                </q-item>
            </q-list>
            
        </q-collapsible>
    </q-list>
</template>

<script>
import { mapGetters } from 'vuex'
export default {

    data() {
        return {
            areas: [],
            tags: [],
            selected_areas: 'all',
            selected_search:'',
            selected_tags:[],
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        fetchAreas() {
            this.$axios.get('/etraining_news/news/news_areas_tags_filters/', this.getHeader)
            .then(response => {
                response.data.areas.map(a => {
                    this.areas.push({ label: a.name, value: a.id })
                })

                response.data.tags.map(a => {
                    this.tags.push({ label: a.name, value: a.id })
                })
            })
        },

        changeFilter() {
            this.$emit('changeFilter', {
                areas:this.selected_areas,
                search: this.selected_search,
                tags: this.selected_tags,
            })
        },

        clearFilters() {
            this.selected_search =  '',
            this.selected_areas =  'all',
            this.selected_tags =  []
            this.$emit('changeFilter', {
                areas:this.selected_areas,
                search: this.selected_search,
                tags: this.selected_tags,
            })
        }
    },

    created() {
        this.fetchAreas()
    }
}
</script>

<style lang="stylus" scoped>
p
    margin 0 0 10px

p
    &.tags
        margin 0 0 5px

a
    text-decoration none
</style>
